import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { track } from '../../analytics/utils';
import { Border, Text } from '../core';
import { ChevronDownIcon } from '../icon';
import { Overlay, Padding, Queue } from '../layout';

const DropDownWrapper = styled.select<any>`
  height: 100%;
  width: 100%;
  opacity: 0;
`;

const DropDownContainer = styled.div<any>`
  position: relative;
  width: 100%;
  height: 100%;
`;

const DropDownOptionsWrapper = styled.div`
  overflow: hidden;
  width: 100%;
`;

const DropDownTextWrapper = styled.div`
  width: 100px;
`;

export const DropDown = (props) => {
  let { description, dropOptions, setOption, option } = props;
  const handleOnChange = (e) => {
    track('Careers Filter Selected', {
      filter_value: e.currentTarget.value,
      filter_category:
        description === 'Filter by location'
          ? _.capitalize('Location')
          : _.capitalize('Department'),
    });
    e.currentTarget.value === description
      ? setOption()
      : setOption(e.currentTarget.value);
  };
  return (
    <DropDownContainer>
      <Border borderSize={[1]} radius="small" borderRole="grey3">
        <Padding size={[3, 5]}>
          <Queue size={4} justifyContent="space-between">
            <DropDownOptionsWrapper>
              {!_.isEmpty(option) ? (
                <DropDownTextWrapper>
                  <Text align="left" ellipsis nowrap textType="primary5">
                    {option}
                  </Text>
                </DropDownTextWrapper>
              ) : (
                <DropDownTextWrapper>
                  <Text
                    align="left"
                    ellipsis
                    nowrap
                    textType="primary5"
                    textRole="light"
                  >
                    {description || 'Oops! Still loading...'}
                  </Text>
                </DropDownTextWrapper>
              )}
            </DropDownOptionsWrapper>
            <ChevronDownIcon />
          </Queue>
        </Padding>
      </Border>
      <Overlay top={0} left={0} right={0} bottom={0}>
        <DropDownWrapper onChange={handleOnChange}>
          <option>{description}</option>
          {_.flow((dropOptions) =>
            _.map(dropOptions, (option, index) => {
              return (
                <option key={index} value={option}>
                  {option}
                </option>
              );
            })
          )(dropOptions)}
        </DropDownWrapper>
      </Overlay>
    </DropDownContainer>
  );
};
